<template>
  <div class="__cont">
    <div class="lottie" ref="lavContainer"></div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import * as animationData from "../../assets/json/loader";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Loading",

  data() {
    return {
      anim: null,
    };
  },
  computed: {
    ...mapGetters(["loaderStatus"]),
  },
  watch: {
    loaderStatus: function (val) {
      if (val) this.play();
      else this.stop();
    },
  },
  methods: {
    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },
  },
  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData.default,
    });
    this.play();
  },
};
</script>

<style scoped lang="scss">
.__cont {
  display: flex;
  height: 100%;
  justify-content: center;
  padding-top: 10%;
  align-items: center;
  .lottie {
    width: 30%;
    height: 100%;
    margin-top: -20%;
    display: flex;
    align-self: center;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    text-align: center;
    opacity: 0.6;
    @media (min-width: 300px) and (max-width: 630px) {
      width: 100%;
    }
    svg {
      width: 30%;
      height: 100%;
      transform: translate3d(0px, 0px, 0px);
      opacity: 0.6;
    }
  }
}
</style>